import GenQCandidateList from "../features/GeneratedQ/GeneratedQCandidate/components/GenQCandidateList";

const GeneratedQCandidateListPage = () => {
    return <GenQCandidateList />;
};

export default GeneratedQCandidateListPage;
